<template lang="html">
    <div>
      <v-dialog
        v-model="ListAlbumsDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-overlay :value="progress">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card :style="stylechat">
          <v-layout
            row
            wrap
            justify-center
            align-center
            class="mt-0 pl-3 pr-3"
            style="height: 65px"
          >
            <v-col
              cols="2"
              justify="center"
              align="center"
              class="pl-2 pr-0 pt-0 pb-0 cursor"
              @click="close()"
            >
              <v-icon style="font-size: 30px !important">mdi-close</v-icon>
            </v-col>
            <v-col cols="8" justify="center" align="center" class="pa-0 pt-0">
              <span class="tab-title mt-0">{{
                $t("AnswerQuestion.selectAlbum")
              }}</span>
            </v-col>
            <v-col
              cols="2"
              justify="center"
              align="center"
              class="pr-2 pl-0 pt-0 pb-0"
            >
            </v-col>
          </v-layout>
          <!-- <v-divider class="mt-4 mb-2"></v-divider> -->
          <div
            class="pt-3 pl-5 pr-5 pb-2 list-overflow"
            id="myscroll"
            v-on:scroll="scrollFunction"
          >
            <v-row class="pa-5 mt-0" @click="openDialog('', '', 'create')">
              <div
                style="
                  background-color: #e5e5e5;
                  min-height: 100px;
                  width: 100px;
                  justify-content: center;
                  align-items: center;
                  display: flex;
                "
              >
                <v-icon>fa-regular fa-images</v-icon>
              </div>
              <v-col class="d-flex child-flex pa-1" cols="8" justify="center">
                <v-row align-center class="pl-1 mb-5">
                  <v-col cols="12">
                    <h3 class="mb-0 mt-0">
                      {{ $t("Dialog.album.headerCreate") }}
                    </h3>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
  
            <v-col
              cols="12"
              v-for="(item, index) in list_albums"
              :key="item._id"
              justify="end"
            >
              <v-row v-if="item.state.status === 'active'" class="cursor">
                <v-col
                  class="d-flex child-flex pa-2"
                  cols="4"
                  @click="openDialog(item, index, 'add-image')"
                >
                  <v-img
                    :src="item.pic_title"
                    :lazy-src="item.pic_title"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    v-if="item.pic_title !== undefined"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-col
                    v-else
                    cols="12"
                    align="center"
                    justify="center"
                    class="col-no-media-not-active"
                  >
                    <div
                      style="
                        min-height: 100px;
                        width: 100px;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                      "
                    >
                      <v-icon>fa-regular fa-images</v-icon>
                    </div>
                  </v-col>
                </v-col>
                <v-col
                  class="d-flex child-flex pa-1"
                  cols="8"
                  justify="center"
                  @click="openDialog(item, index, 'add-image')"
                >
                  <v-row align-center class="pl-1 mb-5">
                    <v-col cols="12">
                      <h3 class="mb-0 mt-0 text-overflow-link">
                        {{ item.albums_name }}
                      </h3>
                      <p class="mb-0 mt-1" style="color: grey">
                        {{ item.information.length }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-card>
        <Warning
          :WarningDialog="WarningDialog"
          :WarningDialogDetail="WarningDialogDetail"
          @emitWarning="emitWarning"
          @closeAlertDialog="closeAlertDialog"
        />
        <ErrorAlert
          :ErrorDialog="ErrorDialog"
          :ErrorDialogDetail="ErrorDialogDetail"
          @closeAlertDialog="closeAlertDialog"
        />
  
        <ListBottomMenu
          :ListBottomMenu="ListBottomMenu"
          :ListBottomItem="ListBottomItem"
          @emitListBottom="emitListBottom"
          @closeAlertDialog="closeAlertDialog"
        />
        <CreatedAlbums
          :ListAlbumsDetail="ListAlbumsDetail"
          :ListAlbumsImage="ListAlbumsImage"
          :AlbumsRoom="AlbumsRoom"
          :tokenuser="tokenuser"
          :CreatedAlbumsDialog="CreatedAlbumsDialog"
          @emitComponents="emitComponents"
          @closeComponents="closeComponents"
        />
        <DetailAlbumsChat
          :AlbumsRoom="AlbumsRoom"
          :DetailAlbumsChatDialog="DetailAlbumsChatDialog"
          :DetailAlbumsDialog="DetailAlbumsDialog"
          @emitComponents="emitComponents"
          @closeComponents="closeComponents"
        />
        <EditNameAlbums
          :EditAlbumsDialog="EditAlbumsDialog"
          :EditAlbumsDetail="EditAlbumsDetail"
          @emitComponents="emitComponents"
          @closeComponents="closeComponents"
        />
        <AddImageAlbum
          :ListAlbumsDetail="ListAlbumsDetail"
          :ListAlbumsImage="ListAlbumsImage"
          :AlbumsRoom="AlbumsRoom"
          :AddImageAlbumsDialog="AddImageAlbumsDialog"
          :DetailAlbums="DetailAlbumsDialog"
          @emitComponents="emitComponents"
          @closeComponents="closeComponents"
        />
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { Momenttime, Decode, Encode } from "@/services";
  import Warning from "@/components/Alert/Warning";
  import ErrorAlert from "@/components/Alert/Error";
  // import LinkPrevue from "link-prevue";
  // import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
  // import { vplayer, aplayer } from "vue-hls-player";
  import ListBottomMenu from "@/components/Alert/ListBottomMenu";
  import EditNameAlbums from "@/components/EditNameAlbumsChat";
  import CreatedAlbums from "@/components/CreatedAlbumsChat";
  import DetailAlbumsChat from "@/components/DetailAlbumsChat";
  import AddImageAlbum from "@/components/AddImageAlbumsChat";
  
  var _ = require("lodash");
  export default {
    props: {
      ListAlbumsDialog: Boolean,
      ListAlbumsDetail: Array,
      ListAlbumsImage: Array,
      AlbumsRoom: String,
      tokenuser: String,
    },
    data() {
      return {
        AddImageAlbumsDialog: false,
        EditAlbumsDialog: false,
        EditAlbumsDetail: {},
        detail_modal: {},
        date_image: "",
        progress_btm: false,
        activeKey: "",
        activeTabName: "",
        // tokenuser: "",
        tokenroom: "",
        data_user: {},
        publicPath: process.env.VUE_APP_BASE_PATH,
        DetailAlbumsDialog: {},
        DetailAlbumsChatDialog: false,
        NoteDetail: {},
        CreatedAlbumsDialog: false,
        ListBottomMenu: false,
        ListBottomItem: [],
        ErrorDialog: false,
        ErrorDialogDetail: {},
        WarningDialog: false,
        WarningDialogDetail: {},
        list_image: [],
        list_file: [],
        list_link: [],
        status_edit: "start",
        limit: 20,
        offset: 0,
        access_token: "",
        refresh_token: "",
        progress: false,
        nextgetMedia: true,
        thumbnail_video: "",
        muted_video: false,
        videoOptions: {
          autoplay: true,
          controls: true,
          muted: false,
          fullscreen: true,
        },
        pageCount: 1,
        page: null,
        numPages: 1,
        urlpdf: "",
        filenamepdf: "",
        sources_video: [],
        list_albums: [],
        stylechat: {
          "--ListAlbums-HeaderColor": "white",
          "--ListAlbums-TabBackground": "white",
          "--ListAlbums-Icon": "gray",
          "--ListAlbums-HeaderPictureBorderRadius": "6px",
          "--ListAlbums-IconActive": "#2662ae",
          "--ListAlbums-Background": "white",
          "--ListAlbums-FontSize": "18px",
          "--ListAlbums-FontSize-Title": "24px",
          "--ListAlbums-FontColor": "back",
          "--ListAlbums-FontSize-Status": "16px",
          "--ListAlbums-FontColor-Status": "grey",
          "--ListAlbums-Background-Input": "#E2E1E3",
          "--ListAlbums-Color-Button": "#EFF2FE",
          "--ListAlbums-FontColor-Button": "#2662ae",
          "--ListAlbums-FontColor-Block-Button": "#cb1002",
          "--ListAlbums-FontColor-Dis-Button": "#e2e1e3",
          "--ListAlbums-Btn-Confirm-Background": "#2662ae",
          "--ListAlbums-Btn-Confirm-Color": "white",
          "--ListAlbums-Btn-Confirm-FontSize": "18px",
          "--ListAlbums-Btn-Cancel-Background": "white",
          "--ListAlbums-Btn-Cancel-Color": "#2662ae",
          "--ListAlbums-Btn-Cancel-FontSize": "18px",
          "--ListAlbums-Btn-Leave-Background": "white",
          "--ListAlbums-Btn-Leave-Color": "#ff5252",
          "--ListAlbums-Btn-Leave-FontSize": "18px",
          "--ListAlbums-FontSize-Title-Edit": "20px",
          "--ListAlbums-MainFontSize-All": this.$store.getters.mainFontSize,
          "--ListAlbums-SubFontSize-All": this.$store.getters.subFontSize,
        },
        business_id: "",
        user_profile: {},
      };
    },
    components: {
      ErrorAlert,
      Warning,
      // LinkPrevue,
      // vplayer,
      // aplayer,
      // VuePdfEmbed,
      ListBottomMenu,
      EditNameAlbums,
      DetailAlbumsChat,
      CreatedAlbums,
      AddImageAlbum,
    },
    watch: {
      ListAlbumsDialog() {
        if (this.ListAlbumsDialog) {
          localStorage.ListAlbumsDetail = JSON.stringify(this.ListAlbumsDetail)
          this.tokenroom = this.AlbumsRoom;
          this.getAlbums();
        }
      },
    },
    created() {
    },
    methods: {
      getAlbums () {
        this.progress = true;
        var body = {
            "tokenroom": this.tokenroom,
            "tokenuser": this.tokenuser
        }
        this.axios
          .post(
            process.env.VUE_APP_API_EVENT + `/getlist_albums`, body).then((response) => {
            if (response.data.status == 'success') {
              this.progress = false;
              // this.list_albums = response.data.data
              this.list_albums.push.apply(this.list_albums, response.data.data);
              this.list_albums = _.unionBy(this.list_albums, "_id");
              this.list_albums = _.orderBy(
                this.list_albums,
                "create_date",
                "desc"
              );
              // console.log(this.list_albums)
            }
          })
          .catch((err) => {
            console.log(err);
            this.progress = false;
            if (err.response.data.status === 401) {
              var data = {
                type: "getAlbums",
                key: "",
              };
            this.ErrorDialogDetail = {
                title: "Error",
                text: err.response.data.message,
              };
              this.ErrorDialog = true;
            } else {
              this.ErrorDialogDetail = {
                title: "Error",
                text: this.$t("Alert.Fail.default.somethingWrong"),
              };
              this.ErrorDialog = true;
            }
          });
      },
      extension(path) {
        var extension = path.split(".")[path.split(".").length - 1].toLowerCase();
        var archive = [
          "zip",
          "jar",
          "rar",
          "tar",
          "a",
          "ar",
          "shar",
          "7z",
          "arj",
          "deb",
          "pkg",
          "gz",
          "rpm",
          "z",
        ];
        var pdf = ["pdf"];
        var spreadsheet = ["xls", "xlsx", "xlt", "xlsm", "xlm", "xlsm", "gsheet"];
        var presentation = ["ppt", "pps", "pot", "pptx"];
        var word = ["doc", "docx", "dot", "dotx", "dotm", "docm", "docb", "wbk"];
        var execution = [
          "apk",
          "bat",
          "bin",
          "pl",
          "cgi",
          "com",
          "exe",
          "gadget",
          "jar",
          "py",
          "vue",
          "wsf",
          "css",
          "htm",
          "html",
          "js",
          "php",
          "xhtml",
          "c",
          "class",
          "cpp",
          "vb",
          "h",
          "sh",
          "swift",
        ];
        var image = [
          "ai",
          "gif",
          "jpeg",
          "jpg",
          "png",
          "bmp",
          "ico",
          "ps",
          "psd",
          "svg",
          "tif",
          "tiff",
        ];
        var media = [
          "mpg",
          "mpeg",
          "avi",
          "wmv",
          "mov",
          "rm",
          "ram",
          "swf",
          "flv",
          "ogg",
          "webm",
          "mp4",
        ];
        var audio = [
          "mp3",
          "wma",
          "aac",
          "ogg",
          "m4a",
          "wav",
          "cda",
          "flac",
          "aiff",
          "caf",
        ];
        if (pdf.includes(extension)) {
          return "fa-solid fa-file-pdf";
        } else if (archive.includes(extension)) {
          return "fas fa-file-archive";
        } else if (spreadsheet.includes(extension)) {
          return "fas fa-file-excel";
        } else if (presentation.includes(extension)) {
          return "fas fa-file-powerpoint";
        } else if (word.includes(extension)) {
          return "fas fa-file-word";
        } else if (execution.includes(extension)) {
          return "fas fa-file-code";
        } else if (image.includes(extension)) {
          return "fas fa-file-image";
        } else if (media.includes(extension)) {
          return "fa-solid fa-file-video";
        } else if (audio.includes(extension)) {
          return "fa-solid fa-file-audio";
        } else {
          return "fas fa-file-alt";
        }
      },
      scrollFunction() {
        // var scroll = this.$el.querySelector('#myscrollNote')
        var scroll = document.getElementById("myscroll");
        // console.log(scroll.scrollTop)
        if (scroll !== null && scroll !== "null") {
          if (
            scroll.scrollTop + scroll.clientHeight >=
            scroll.scrollHeight * 0.6
          ) {
            // this.getAlbums();
          } else {
            if (scroll.scrollTop === 0) {
              this.offset = 0;
            }
          }
        }
      },
      emitListBottom(value) {
        // console.log(value)
        this.ListBottomMenu = false;
        if (value.item.actions === "delete-album") {
          this.openDialog(value.item, value.item.index, "delete-album");
        } else if (value.item.actions === "edit-album") {
          this.EditAlbumsDetail = value.item.item;
          this.EditAlbumsDialog = true;
        }
        // else if (value.item.actions === "add-image") {
        // }
      },
      emitComponents(value) {
        // console.log(value)
        if (value.name === "create-album") {
          this.CreatedAlbumsDialog = false;
          // this.getNote()
          this.list_image.unshift(value.item);
          this.list_image = _.unionBy(this.list_image, "note_id");
          this.list_image = _.orderBy(this.list_image, "updated_at", "desc");
        } else if (value.name === "detail-note") {
          this.DetailAlbumsDialog = false;
          // this.getNote()
        } else if (value.name === "edit-album") {
          this.offset = 0;
          // this.list_image = []
          this.EditAlbumsDetail = {};
          this.EditAlbumsDialog = false;
          this.getAlbums();
        } else if (value.name === "delete-album") {
          this.DetailAlbumsDialog = false;
          var index = _.findIndex(this.list_albums, function (o) {
            return o.album_id === value.item.id;
          });
          if (index !== -1) {
            this.list_albums.splice(index, 1);
          }
        } else if (value.name === "add-image") {
          this.AddImageAlbumsDialog = false;
          this.CreatedAlbumsDialog = false;
          // this.ListAlbumsDialog = false
          this.$emit("emitComponents", {
            name: "list-albumschat",
            value: false,
            item: value.item,
          });
        }
      },
      openDialog(item, index, type) {
        // console.log(item)
        if (type === "create") {
          this.CreatedAlbumsDialog = true;
        } else if (type === "edit") {
          this.ListBottomItem = [
            {
              text: this.$t("Dialog.album.btnAddImage"),
              icon: "fa-solid fa-image",
              actions: "add-image",
              id: item.album_id,
              index: index,
              item: item,
            },
            {
              text: this.$t("Dialog.album.btnEdit"),
              icon: "fa-solid fa-pen-to-square",
              actions: "edit-album",
              id: item.album_id,
              index: index,
              item: item,
            },
            {
              text: this.$t("Dialog.album.btnRemoveAlbum"),
              icon: "fa-solid fa-trash-can",
              actions: "delete-album",
              id: item.album_id,
              index: index,
            },
          ];
          this.ListBottomMenu = true;
        } else if (type === "delete-album") {
          this.WarningDialogDetail = {
            title: this.$t("Alert.Sure"),
            text: this.$t("Alert.Album.deleteAlbum"),
            detail: item,
            index: index,
            type: "delete-album",
          };
          this.WarningDialog = true;
        } else if (type === "detail-album") {
          // เอาไว้เช็คตอนกดปุ่มไอคอน list ว่าจะให้ปิดหน้ารายการโน้ตหรือให้แสดงอันใหม่ กรณีที่อยู่ในหน้าแชทหรือในหน้าโน้ต
          item.previous = "list-album";
          this.DetailAlbumsDialog = item;
          this.DetailAlbumsChatDialog = true;
        } else if (type === "add-image") {
          this.DetailAlbumsDialog = item;
          this.AddImageAlbumsDialog = true;
        }
      },
      close() {
        this.offset = 0;
        this.list_albums = [];
        this.$emit("closeComponents", {
          name: "list-albumschat",
          value: false,
        });
      },
      emitWarning(item) {
        // console.log(item)
        this.WarningDialog = false;
        if (item.type === "delete-album") {
          this.deleteAlbum(item.detail.id, item.index);
        }
      },
      closeComponents(data) {
        console.log("closeComponents =>", data)
        if (data.name === "create-album") {
          this.CreatedAlbumsDialog = data.value;
          this.offset = 0;
          this.getAlbums();
        } else if (data.name === "edit-album") {
          this.EditAlbumsDialog = data.value;
        } else if (data.name === "detail-album") {
          this.DetailAlbumsChat = {};
          this.DetailAlbumsChatDialog = data.value;
          this.offset = 0;
          this.getAlbums();
        } else if (data.name === "delete-album") {
          this.DetailAlbumsDialog = {};
          this.DetailAlbumsChatDialog = data.value;
          this.offset = 0;
          this.getAlbums();
        } else if (data.name === "add-image") {
          this.DetailAlbumsDialog = {};
          this.AddImageAlbumsDialog = data.value;
          this.progress = true
          this.list_albums = []
          this.getAlbums();
        }
      },
      closeAlertDialog(data) {
        // console.log(data)
        if (data.type === "warning") {
          this.WarningDialog = data.value;
        } else if (data.type === "err") {
          this.ErrorDialog = data.value;
        } else if (data.type === "bottommenu") {
          this.ListBottomMenu = data.value;
        }
      },
    },
  };
  </script>
  
  <style lang="css" scoped>
  .cursor {
    cursor: pointer;
  }
  .col-no-media-not-active {
    border-style: solid;
    border-width: thin;
    border-radius: 15px;
    background-color: #8080801c;
    border-color: #8080801c;
    height: 100px;
    align-items: center;
    justify-content: center;
    display: flex;
    /* color: #d7d7d7; */
    color: #818181;
  }
  .color-white {
    color: white !important;
  }
  .fz-20 {
    font-size: 20px !important;
  }
  >>> .player__controls--progress {
    flex: 1 !important;
    margin: 0 8px !important;
    z-index: 0 !important;
  }
  >>> .aplayer .player__controls--durration {
    color: rgb(0 0 0) !important;
  }
  >>> .video-js {
    display: block;
    vertical-align: top;
    box-sizing: border-box;
    color: #fff;
    background-color: #000;
    position: relative;
    padding: 0;
    font-size: 10px;
    line-height: 1;
    font-weight: 400;
    font-style: normal;
    font-family: Arial, Helvetica, sans-serif;
    word-break: initial;
    /* height: 100% !important; */
    width: 100% !important;
  }
  .modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
  }
  
  .modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
  }
  
  #headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--ListAlbums-HeaderPictureBorderRadius) !important;
  }
  .height-80vh {
    height: 80vh;
    overflow: hidden;
  }
  .col-no-media {
    border-style: solid;
    border-width: thin;
    border-radius: 15px;
    background-color: #8080801c;
    border-color: #8080801c;
    height: 100px;
    align-items: center;
    justify-content: center;
    display: flex;
    color: gray;
  }
  .text-overflow-link {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 60vw;
  }
  >>> .v-list-item .v-list-item__title {
    line-height: 2 !important;
  }
  .fz-19 {
    font-size: 19px;
  }
  .fw-600 {
    font-weight: 600;
  }
  .centerimg_website {
    justify-content: center;
    display: flex;
    margin-bottom: 10px;
  }
  .img_website {
    height: 50px;
    width: 50px;
    margin: auto;
    border-radius: 10px;
    object-fit: cover;
  }
  .layout-panels {
    height: calc(100vh - 140px) !important;
    /* height: 210px; */
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .layout-panels::-webkit-scrollbar {
    width: 3px;
  }
  
  .layout-panels::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
  
  >>> .ant-tabs-nav .ant-tabs-tab-active {
    color: var(--ListAlbums-IconActive) !important;
    text-shadow: 0 0 0.25px currentColor !important;
  }
  >>> .ant-tabs-ink-bar {
    position: absolute;
    bottom: 1px;
    left: 0;
    z-index: 0;
    box-sizing: border-box;
    height: 2px;
    background-color: var(--ListAlbums-IconActive) !important;
    transform-origin: 0 0;
  }
  .font-list-title {
    font-weight: 600;
    color: var(--ListAlbums-FontColor) !important;
  }
  .width-100 {
    width: 100% !important;
  }
  .fz-30 {
    font-size: 30px !important;
  }
  .fz-50 {
    font-size: 50px !important;
  }
  .text-transform {
    text-transform: none;
  }
  .text-title {
    font-size: var(--ListAlbums-FontSize-Title) !important;
    color: var(--ListAlbums-FontColor) !important;
    font-weight: 600;
  }
  .text-title-edit {
    font-size: var(--ListAlbums-FontSize-Title-Edit) !important;
    color: var(--ListAlbums-FontColor) !important;
  }
  .tab-title {
    color: var(--ListAlbums-FontColor) !important;
    font-size: var(--ListAlbums-FontSize) !important;
    font-weight: 600;
  }
  .tab-title-status {
    color: var(--ListAlbums-FontColor-Status) !important;
    font-size: var(--ListAlbums-FontSize-Status) !important;
  }
  .text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 50vw;
  }
  .text-overflow-modal {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }
  .checkbox-color {
    color: var(--ListAlbums-IconActive) !important;
  }
  >>> .v-application .elevation-10 {
    box-shadow: none !important;
  }
  >>> .theme--light.v-sheet {
    box-shadow: none !important;
  }
  .list-overflow {
    height: calc(100vh - 64px) !important;
    overflow-y: scroll;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .list-overflow::-webkit-scrollbar {
    width: 3px;
  }
  
  .list-overflow::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
  
  .list-overflow-select {
    height: calc(100vh - 210px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .list-overflow-select::-webkit-scrollbar {
    width: 3px;
  }
  
  .list-overflow-select::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
  /* >>>.v-input__slot {
    background-color: var(--ListAlbums-Background-Input) !important;
    border-radius: 10px !important;
  } */
  >>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
    > .v-input__control
    > .v-input__slot {
    box-shadow: none !important;
    background-color: var(--ListAlbums-Background-Input) !important;
    border-radius: 10px !important;
  }
  >>> .v-dialog--fullscreen {
    border-radius: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    /* overflow-y: auto; */
    top: 0;
    left: 0;
    overflow: hidden;
  }
  >>> .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }
  .icon-color-edit {
    color: var(--ListAlbums-Icon) !important;
  }
  .icon-color {
    color: var(--ListAlbums-IconActive) !important;
  }
  .btn-confirm {
    background-color: var(--ListAlbums-Btn-Confirm-Background) !important;
    color: var(--ListAlbums-Btn-Confirm-Color) !important;
    font-size: var(--ListAlbums-Btn-Confirm-FontSize) !important;
    font-weight: 600;
  }
  .btn-cancel {
    background-color: var(--ListAlbums-Btn-Cancel-Background) !important;
    color: var(--ListAlbums-Btn-Cancel-Color) !important;
    font-size: var(--ListAlbums-Btn-Cancel-FontSize) !important;
    font-weight: 600;
  }
  .btn-leave {
    background-color: var(--ListAlbums-Btn-Leave-Background) !important;
    color: var(--ListAlbums-Btn-Leave-Color) !important;
    font-size: var(--ListAlbums-Btn-Leave-FontSize) !important;
    font-weight: 600;
  }
  .img-position {
    object-fit: cover;
    object-position: 50% 0;
    border-style: solid;
    border-width: thin;
    border-color: #e8e8e8;
  }
  .layout-page {
    /* height: calc(100vh - 64px) !important; */
    height: 100vh !important;
    overflow: hidden !important;
    background-color: var(--ListAlbums-Background) !important;
  }
  
  .text-transform {
    text-transform: none;
  }
  .text-title {
    font-size: var(--ListAlbums-FontSize-Title) !important;
    color: var(--ListAlbums-FontColor) !important;
    font-weight: 600;
  }
  /* .text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 70vw;
  } */
  .main-fontsize {
    font-size: var(--ListAlbums-MainFontSize-All) !important;
  }
  .sub-fontsize {
    font-size: var(--ListAlbums-SubFontSize-All) !important;
  }
  </style>
  